class TypographyService {
  public static camelCase(str: string): string {
    if (!str) return '';

    const words = str.split(/[^a-zA-Z0-9]/);

    return words
      .map((word, index) =>
        index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      )
      .join('');
  }

  public static camelCaseToLabel(camelCasedString: string) {
    return `${camelCasedString?.[0].toUpperCase()}${camelCasedString.slice(1)}`.replace(/[A-Z]/g, ' $&').trim();
  }

  public static pascalCase(str?: string) {
    if (!str?.length) {
      return str;
    }
    return str[0].toUpperCase() + TypographyService.camelCase(str.slice(1));
  }

  public static capitalize(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  public static decapitalize(str: string): string {
    if (!str) return '';
    return str.charAt(0).toLowerCase() + str.slice(1);
  }

  public static splitByCapitalLetters(str: string): string {
    return str.replace(/([A-Z])/g, ' $1').trim();
  }

  public static removeWordFromLabel(label: string, wordToRemove: string): string {
    return this.camelCaseToLabel(label)
      .split(' ')
      .filter((word) => !(word.toLowerCase() === wordToRemove))
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}

export default TypographyService;
